import React from 'react'
import RewardLeaderboardPage from './RewardLeaderboardPage'

const RewardCashbackPage: React.FC = () => <RewardLeaderboardPage tab="cashback" />

export default RewardCashbackPage
